/**
 * Notification chime — synthesized via Web Audio API.
 * No external asset; works offline and avoids bundling .mp3.
 */

let audioCtx = null
let enabled = false

function ctx() {
  if (audioCtx) return audioCtx
  const AC = window.AudioContext || window.webkitAudioContext
  if (!AC) return null
  audioCtx = new AC()
  return audioCtx
}

export function setAudioEnabled(v) { enabled = !!v }
export function getAudioEnabled() { return enabled }

export function playChime() {
  if (!enabled) return
  const c = ctx()
  if (!c) return
  try {
    if (c.state === 'suspended') c.resume()
    const now = c.currentTime

    // Two-note chime: G5 then C6, both quick decay
    const notes = [
      { freq: 783.99, start: 0,    dur: 0.18 },
      { freq: 1046.5, start: 0.12, dur: 0.22 },
    ]
    for (const n of notes) {
      const o = c.createOscillator()
      const g = c.createGain()
      o.type = 'sine'
      o.frequency.value = n.freq
      g.gain.setValueAtTime(0.0001, now + n.start)
      g.gain.exponentialRampToValueAtTime(0.18, now + n.start + 0.01)
      g.gain.exponentialRampToValueAtTime(0.0001, now + n.start + n.dur)
      o.connect(g).connect(c.destination)
      o.start(now + n.start)
      o.stop(now + n.start + n.dur + 0.02)
    }
  } catch (e) {
    /* user gesture not present yet; ignore */
  }
}
